// eslint-disable-next-line
export default (value: string): string =>
  value
    .replace(/<\/p>(\s*)<p\b((?:[^>"']|"[^"]*")*)>/g, '<br /> <br />')
    .replace(/<(\/?)p\b((?:[^>"']|"[^"]*")*)>/g, '');
